// Import 3rd-party dependencies
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

// Import project-specific dependencies
import { IFavoriteResourceLink } from '@app/services/favorites/favorites.service';
import { urlValidator } from '@app/shared/validators/url.validator';
import { EDIT_FAVORITES_DIALOG_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-edit-favorite-dialog',
  templateUrl: './edit-favorite-dialog.component.html',
  styleUrls: ['./edit-favorite-dialog.component.css']
})
export class EditFavoriteDialogComponent implements OnInit {
  // Class attributes
  editForm: FormGroup;
  description: string;
  link1: IFavoriteResourceLink;

  consts = EDIT_FAVORITES_DIALOG_COMPONENT_CONSTS;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditFavoriteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFavoriteResourceLink
  ) {}

  ngOnInit(): void {
    this.editForm = this.fb.group({
      name: [
        this.data.name,
        [
          Validators.required // eslint-disable-line @typescript-eslint/unbound-method
        ]
      ],
      link: [
        this.data.link,
        [
          Validators.required, // eslint-disable-line @typescript-eslint/unbound-method
          urlValidator
        ]
      ],
      customLink: this.data.customLink,
      dateTimeFavorited: new Date()
    });
  }

  onSave(): void {
    if (!this.editForm.invalid) {
      this.dialogRef.close(this.editForm.value);
    }
  }
}
